<template>
  <div>
   <div class="searchBox" v-if="userId==1">
    <div class="searchLeft">
      <p style="margin-left:20px;display:inline-block;">
        <span>Profit Wallet钱包余额：</span>
        <span style="color:red;font-size:20px;">{{balance?balance+' FIL':0}}</span>
      </p>
      <p style="margin-left:20px;display:inline-block;">
        <span>Pleage Wallet钱包余额：</span>
        <span style="color:red;font-size:20px;">{{balanceTwo?balanceTwo+' FIL':0}}</span>
      </p>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    :cell-style="getRowClass"
    style="width: 100%">
    <el-table-column
      prop="userName"
      width="160"
      label="提币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.applyTime)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="180"
      prop="id"
      label="提币单号">
    </el-table-column>
    <el-table-column
      prop="userId"
      label="用户ID">
    </el-table-column>
    <el-table-column
      prop="userName"
      label="真实姓名">
    </el-table-column>
    <el-table-column
      prop="phone"
      width="120px"
      label="手机号">
    </el-table-column>
    <el-table-column
      prop="email"
      width="200px"
      label="邮箱">
    </el-table-column>
    <el-table-column
      prop="coinName"
      label="提币币种">
    </el-table-column>
    <el-table-column
      width="120"
      label="申请前数量">
      <template slot-scope="scope">
        <span>{{scope.row.beforeBalance}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="提币数量">
      <template slot-scope="scope">
        <span>{{scope.row.applyMoney}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="120"
      label="申请后数量">
      <template slot-scope="scope">
        <span>{{scope.row.afterBalance}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="400px"
      prop="walletAddr"
      label="提币地址">
    </el-table-column>
    <el-table-column
      width="120px"
      prop="actualFee"
      label="提币手续费">
    </el-table-column>
    <el-table-column
      prop="auditStatus"
      label="审核状态">
      <template slot-scope="scope">
        <span>{{scope.row.auditStatus==0?"待审核":scope.row.auditStatus==1?"已审核":scope.row.auditStatus==2?"拒绝":"未知"}}</span>
      </template>
    </el-table-column>
    <!-- <el-table-column
      prop="state"
      label="异常状态">
      <template slot-scope="scope">
        <span v-if="scope.row.errorStatus==1" style="color:#e6a23c">安全</span>
        <span v-if="scope.row.errorStatus==2" style="color:#e6a23c">待定</span>
        <span v-if="scope.row.errorStatus==3" style="color:#F56C6C">异常</span>
      </template>
    </el-table-column> -->
    <el-table-column
      prop="state"
      label="链上状态">
      <template slot-scope="scope">
        <span>{{scope.row.transStatus=='PENDING'?"交易中":scope.row.transStatus=='DONE'?"已完成":scope.row.transStatus=='FAILED'?"失败":""}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="100"
      prop="requiredPassNum"
      label="审核人数">
    </el-table-column>
    <el-table-column
      width="100"
      prop="passNum"
      label="已审核人数">
    </el-table-column>
    <el-table-column fixed="right" label="操作" align="center" prop="time" width="300">
        <template slot-scope="scope" >
          <el-button size="mini" type="primary" @click="checkData(scope.row)" ><i class="el-icon-view" style="margin-right:3px;"></i>查看</el-button>
          <el-button size="mini" type="primary" @click="passStatus(scope.row, 1)" v-if="!scope.row.audited"><i class="el-icon-edit" style="margin-right:3px;"></i>通过</el-button>
          <el-button size="mini" type="primary" @click="passStatus(scope.row, 0)" v-if="!scope.row.audited"><i class="el-icon-edit" style="margin-right:3px;"></i>拒绝</el-button>
          <el-button size="mini" type="primary" @click="passList(scope.row)" ><i class="el-icon-view" style="margin-right:3px;"></i>审核明细</el-button>
        </template>
      </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 30, 40]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="审核明细"
      :visible.sync="dialogVisible"
      width="600px">
        <el-table
        border
        :data="auditRecordsList"
        height="30vh"
        style="width: 100%">
        <el-table-column
          prop="createTime"
          width="160"
          label="审核时间">
        </el-table-column>
        <el-table-column
          prop="auditUser"
          label="审核人">
        </el-table-column>
        <el-table-column
          prop="pass"
          label="审核状态">
          <template slot-scope="scope">
            <span>{{scope.row.pass?'通过':'拒绝'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="auditRemark"
          label="审核备注">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="cheack_box"
      :visible.sync="dialogVisibleTwo"
      width="600px"
    >
      <div class="cheackBox" v-if="financeInfo">
        <div class="title">账户可用余额:  {{$selfFunc.toNonExponential(financeInfo.balance,4) + ' ' +coinName}}</div>
        <div class="samll_box fiex">
          <div>链上充值: {{$selfFunc.toNonExponential(financeInfo.rechargeDone,4) + ' ' +coinName}}</div>
          <div>链上提币: {{$selfFunc.toNonExponential(financeInfo.withdrawDone,4) + ' ' +coinName}}</div>
          <div>提币中: {{$selfFunc.toNonExponential(financeInfo.withdrawPending,4) + ' ' +coinName}}</div>
        </div>
        <div class="samll_box" :class="coinName=='USDT'? 'fiex1': 'fiex'">
          <div v-if="coinName=='USDT'">已发放推广收益: {{$selfFunc.toNonExponential(financeInfo.settlementAgentIncome,4) + ' ' +coinName}}</div>
          <div v-if="coinName=='FIL'">已释放收益: {{$selfFunc.toNonExponential(financeInfo.releaseIncome,4) + ' ' +coinName}}</div>
          <div v-if="coinName=='FIL'">差额：{{$selfFunc.toNonExponential(financeInfo.balanceDiff,4)}}</div>
          <div v-if="coinName=='FIL'">差额百分比：{{financeInfo.balanceDiffRate?$selfFunc.toNonExponential(financeInfo.balanceDiffRate,4) + '%':'--'}}</div>
          <!-- <div v-if="coinName=='FIL'">差额: {{$selfFunc.toNonExponential(
            (Number(financeInfo.rechargeDone))+(Number(financeInfo.releaseIncome))
            +(Number(financeInfo.pledgeBack))-(Number(financeInfo.balance))-(Number(financeInfo.withdrawDone))-(Number(financeInfo.withdrawPending))-(Number(financeInfo.orderUsed)),4) + ' ' +coinName}}</div> -->
          <!-- <div v-if="coinName=='FIL'">差额百分比: {{($selfFunc.toNonExponential(
            (Number(financeInfo.rechargeDone))+(Number(financeInfo.releaseIncome))
            +(Number(financeInfo.pledgeBack))-(Number(financeInfo.balance))-(Number(financeInfo.withdrawDone))-(Number(financeInfo.withdrawPending))-(Number(financeInfo.orderUsed)),4)/$selfFunc.toNonExponential(financeInfo.frozenIncome,4)*100).toFixed(2)+ ' ' +'%'}}</div> -->
        </div>
        <div class="ge"></div>
        <div class="samll_box fiex yes" v-if="coinName=='USDT'">
          <div>购买存储: {{$selfFunc.toNonExponential(financeInfo.orderUsed,4) + ' ' +coinName}}</div>
          <div>推广收益: {{$selfFunc.toNonExponential(financeInfo.agentIncome,4) + ' ' +coinName}}</div>
          <div>待发放推广收益: {{$selfFunc.toNonExponential(financeInfo.unsettlementAgentIncome,4) + ' ' +coinName}}</div>
        </div>
        <div class="samll_big yes" v-if="coinName=='FIL'">
          <div class="samll_box fiex">
            <div>总收益:  {{$selfFunc.toNonExponential(financeInfo.totalIncome,4) + ' ' +coinName}}</div>
            <div>存储收益: {{$selfFunc.toNonExponential(financeInfo.orderIncome,4) + ' ' +coinName}}</div>
            <div>推广收益: {{$selfFunc.toNonExponential(financeInfo.agentIncome,4) + ' ' +coinName}}</div>
          </div>
          <div class="samll_box fiex">
            <div>待释放收益: {{$selfFunc.toNonExponential(financeInfo.frozenIncome,4) + ' ' +coinName}}</div>
            <div>购买存储:  {{$selfFunc.toNonExponential(financeInfo.orderUsed,4) + ' ' +coinName}}</div>
            <div>质押币退回: {{$selfFunc.toNonExponential(financeInfo.pledgeBack,4) + ' ' +coinName}}</div>
          </div>
          <div class="samll_box">
            <div>其它收益: {{$selfFunc.toNonExponential(financeInfo.otherIncome,4) + ' ' +coinName}}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.end_time;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.start_time;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      walletId: '',
      type: '',
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        startTime:'',
        endTime:'',
        auditStatus: 0,
        autoPass:0
      },
      tableData: [],
      selectTableData:[],
      multipleSelection: [],
      totalSumWithdraw:0,
      exportList:[],
      dialogVisible:false,
      dialogVisibleTwo: false,
      coinName: null,
      financeInfo: null,
      balance: 0,
      balanceTwo: 0,
      ruleForm:{
        refundId:'',
        refundStatus:'',
        refuseDirections:''
      },
      rules:{
        refuseDirections:[
          { required: true, message: '请输入拒绝理由', trigger: 'blur' }
        ]
      },
      userId: '',
      auditRecordsList: []
    };
  },
  created() {
    this.getTableList()
    // this.getSumWithdrawal()
    // this.getBalance()
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }){
      console.log(row)
      if (row.errorStatus==3) {
        return 'background-color:#f3a1a1'
      } else if (row.errorStatus==2){
        return 'background-color:#f5cd91'
      }
    },
    async checkData(row){
      this.coinName = row.coinName
      let res = await this.$http.withdrawFinanceInfo({withdrawalId:row.id});
      if (res) {
        this.financeInfo = res.data
        this.dialogVisibleTwo = true
      }
    },
    async passList(row){
      let res = await this.$http.auditRecords({withdrawalId:row.id});
      if (res) {
        this.auditRecordsList = res.data
        this.dialogVisible = true
      }
    },
    async getBalance () {
      let res = await this.$http.getProfitWalletBalance({});
      if (res) {
        this.balance = res.data.profitWalletBalance
        this.balanceTwo = res.data.pledgeWalletBalance
      }
    },
    passStatus(row, type) {
      let msg
      if (type==1) {
        msg = "此操作将通过该条提币审核数据，操作备注可填"
      } else {
        msg = "此操作将拒绝该条提币审核数据，请填写操作备注信息"
      }
      this.$prompt(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        let data = {
          id: row.id,
          pass: type,
          auditRemark: value
        }
        let res = await this.$http.audit({...data});
        if (res) {
          this.$message.success('操作成功！');
          this.getTableList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if(val.length>0){
        this.selectTableData=val;
      }else {
        this.selectTableData=this.exportList;
      }
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
      let res = await this.$http.listPageForAdmin({...this.searchForm});
      if (res) {
        this.tableData=res.data.list
        this.totalNum=res.data.totalSize
      }
    },
    refundAllFunc(state){
      if(this.multipleSelection.length==0) {
        this.$message('你还没有选择要转款的数据项！');
        return;
      }
      this.$confirm(`确定批量${state==2?'打款':'退回'}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let idArr=this.multipleSelection.map(x=>{
          return x.id
        })
        let res = await this.$http.changeWithdrawaFlagForAdmin({ids:idArr.join(','),flag:state});
        if (res) {
          this.$message.success('操作成功！');
          this.getTableList()
        }
      }).catch(() => {
              
      });
    },
    refundFunc(id, type){
      this.walletId = id 
      this.type = type
      if (type == 3) {
        this.dialogVisible = true
      } else {
        this.$confirm('此操作允许该条提现通过, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = {
            walletId: this.walletId,
            withdrawStatus: this.type
          }
          let res = await this.$http.walletWithdrawalVerify({...data})
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });          
        });
      }
      
      
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data
          if (this.type == 3) {
            data = {
              walletId: this.walletId,
              withdrawStatus: this.type,
              auditDescription: this.ruleForm.refuseDirections
            }
          }
          let res = await this.$http.walletWithdrawalVerify({...data})
          if (res) {
            this.$message.success('操作成功！');
            this.dialogVisible=false
            this.getTableList()
          }
        } else {
          this.$message.success('请填写拒绝原因');
          return false;
        }
      })
    },  
    async getSumWithdrawal(){
      let res = await this.$http.sumWithdrawal();
      if (res) {
        this.totalSumWithdraw=res.data.totalSumWithdrawActual
      }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style scoped>
.moneys{
  font-size: 20px;
  color: #ff444d;
}
.cheackBox{
  color: #333;
  padding-bottom: 20px;
}
.title{
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  color: #333;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.fiex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fiex1{
  display: flex;
  align-items: center;
}
.samll_box{
  height: 30px;
  line-height: 30px;
}
.samll_box div{
  width: 200px;
}
.ge{
  border-bottom: 1px solid #eee;
  margin: 10px 0;
}
.yes{
  color: #999;
}
</style>
<style>
.cheack_box .el-dialog__body{
  padding: 0 20px;
}
</style>
